module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.urlId) ? _c('button', {
    staticClass: "audio-btn",
    class: {
      errorBtn: _vm.error
    },
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('inline-svg', {
    staticClass: "speaker-svg",
    class: {
      errorBtn: _vm.error
    },
    attrs: {
      "src": require('../../assets/svg/play2.svg').default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db1a798","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/audioBtnNoPreLoad.vue
// module id = 335
// module chunks = 0 6